import React from "react";
import DOMPurify from "dompurify";
import { Box, Typography, Link, IconButton } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import DeleteIcon from "@mui/icons-material/Delete";

export default function NotificationTile({
  title,
  message,
  date,
  isRead,
  theme,
  onViewFullOrder,
  onDelete,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center", 
        padding: "16px",
        marginBottom: "12px",
        backgroundColor: isRead ? theme.palette.grey.light : "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <Box sx={{ display: "flex", flexDirection: "row", flex: 1 }}>
          {!isRead && (
            <CircleIcon
              color="green"
              fontSize="inherit"
              sx={{ marginTop: "8px", marginRight: "8px" }}
            />
          )}
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", marginBottom: "8px" }}
          >
            {title}
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{ color: "#757575", marginBottom: "8px" }}
          component="div"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(message, {
              ALLOWED_TAGS: ["br", "a", "strong", "em", "p"],
              ALLOWED_ATTR: ["href", "target", "rel"],
            }),
          }}
        />
        <Typography variant="caption" sx={{ color: "#9e9e9e" }}>
          {date}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Link
          component="button"
          variant="body2"
          onClick={onViewFullOrder}
          sx={{
            color: "#1976d2", 
            fontWeight: "bold",
            fontSize: "17px", 
            textDecoration: "none",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline", 
            },
          }}
        >
          View Details
        </Link>
        <IconButton
          onClick={onDelete}
          color="error"
          size="small"
          sx={{
            "&:hover": {
              backgroundColor: "rgba(211, 47, 47, 0.04)",
            },
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
